export const convertStringToLocalDate = (dateString: string): Date => {
  if (dateString) {
    const currentDate: Date = new Date(dateString);
    return new Date(currentDate.getTime() + currentDate.getTimezoneOffset() * 60000);
  } else {
    return null;
  }
};
